export default __webpack_public_path__ + "static/media/westvirginia.0426fb61.jpg";